@if (toggle && featureStatus) {
  <div class="chart-block">
    @if (chart.disclaimer) {
      <span class="poi-disclaimer">{{ chart.disclaimer }}</span>
    }

    <!-- The switch works whether or not the chart is paid for: opening a chart
         is how someone finds out what it holds, and the paywall sits on the
         chart itself. -->
    <app-slide-toggle
      class="menu-toggle"
      [formControl]="toggle"
      [disabled]="disableToggle"
      [ngClass]="disableToggle ? 'disabled' : ''"
      [attr.data-cy]="'toggle-' + chart.e2eName"
      >{{ chart.toggleTitle }}

      @if (chart.tooltip || lock) {
        <app-feature-tooltip
          [headerText]="chart.tooltip ? chart.tooltip.headerText : ''"
          [isFeatureInaccessibleType]="!!lock"
          [tooltipText]="chart.tooltip ? chart.tooltip.text : ''"
          [featureConst]="chart.featureConst"
          [featureName]="chart.toggleTitle"
          (openTooltipModal)="handleTooltipModalOpen($event)"
        ></app-feature-tooltip>
      }
    </app-slide-toggle>

    <!-- Nothing to pick a year for while the numbers are behind the blur. -->
    @if (!lock && chart.accessibleYears && chart.accessibleYears.length > 0) {
      <app-chart-year-selection
        [isChartVisible]="featureStatus!.isSelected && toggle && toggle!.value"
        [selectedYear]="$any(featureStatus)![chart.yearVariable!]"
        [accessibleYears]="chart.accessibleYears"
        [usedFor]="chart.yearVariable!"
        (selectedYearChange)="onSelectedYearChange($event)"
      ></app-chart-year-selection>
    }

    <!-- A reselect sets isLoading again while this chart's previous data is
         still sitting in featureStatus - so once there is a chart to show,
         a reload plays as an overlay on top of it instead of pulling it out
         from under the visitor. Only a first-ever load, with nothing drawn
         yet, falls back to the plain placeholder below. -->
    @if (
      toggle.value &&
      featureStatus!.isSelected &&
      $any(featureStatus)[chart.containsChartDataVariable]
    ) {
      <div class="chart-wrap">
        @if (lock) {
          <!-- The chart itself, blurred: the shape of the answer is the tease,
               the numbers are what is being sold. The gate line sits directly on
               top of it so the ask is read before the blur is. -->
          <div
            class="locked"
            [class.locked--free]="lock.free"
            (click)="requestUnlock()"
            data-cy="chart-paywall"
          >
            <div class="locked__gate">
              <svg appLockIcon class="locked__lock"></svg>
              <span class="locked__note">{{ lock.note }}</span>
              <button
                type="button"
                class="gradient-button locked__cta"
                [attr.aria-label]="
                  lock.aria + ' the ' + chart.chartName + ' chart'
                "
              >
                {{ lock.cta }}
              </button>
            </div>

            <div class="locked__chart" aria-hidden="true">
              <ng-container *ngTemplateOutlet="chartCanvas"></ng-container>
            </div>
          </div>
        } @else {
          <div class="chart">
            <ng-container *ngTemplateOutlet="chartCanvas"></ng-container>
          </div>
        }

        @if (featureStatus.isLoading) {
          <div class="chart-reload" data-cy="chart-skeleton">
            <span class="visually-hidden"
              >Loading the {{ chart.chartName }} chart</span
            >
          </div>
        }
      </div>
    } @else if (toggle.value && featureStatus.isLoading) {
      <div
        class="chart-skeleton"
        [style.height]="skeletonHeight"
        data-cy="chart-skeleton"
      >
        <span class="visually-hidden"
          >Loading the {{ chart.chartName }} chart</span
        >
      </div>
    }

    <app-chart-warning
      [selectedYear]="
        wasYearSelected ? $any(featureStatus)![chart.yearVariable!] : undefined
      "
      [selected]="featureStatus.isSelected"
      [containsInfo]="$any(featureStatus)[chart.containsChartDataVariable]"
      [isLoading]="!!featureStatus.isLoading"
      [isToggleActive]="toggle && toggle.value"
      [noAccessibleYears]="chart.accessibleYears?.length === 0"
    ></app-chart-warning>
  </div>
}

<!-- One definition for both renderings: locked only changes what is wrapped
     around the chart, never the chart. -->
<ng-template #chartCanvas>
  <app-plotly-chart
    [naturalId]="featureStatus!.naturalId"
    [selectedYear]="$any(featureStatus)![chart.yearVariable!]"
    [chart]="
      chart.plotlyChart ||
      chart.chartsByYears![$any(featureStatus)[$any(chart.yearVariable)]]
    "
    [chartStyle]="chart.chartStyle || defaultChartStyle"
    [chartName]="chart.chartName"
    [e2eName]="chart.e2eName"
    [featureConst]="chart.featureConst"
  ></app-plotly-chart>
</ng-template>
